import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import api from "../../../services/api";
import StatusTimeline from "./StatusTimeline";
import PositionInfo from "./PositionInfo";
import SheetsModal from "./SheetsModal";
import { statusMap } from "./constants";

export default function StatusHistoryModal({ show, onClose, position }) {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [showSheetsModal, setShowSheetsModal] = useState(false);

  useEffect(() => {
    if (!show || !position) return;

    const fetchHistory = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/orders/status-history/${position.orderPositionId}`);
        const fetchedRecords = res.data?.records || [];
        const sortedRecords = fetchedRecords.sort((a, b) => 
          new Date(a.creationTime) - new Date(b.creationTime)
        );
        setRecords(sortedRecords);
      } catch (err) {
        console.error("Ошибка загрузки истории статусов", err);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [show, position]);

  if (!position) return null;

  const hasPrintingAwaiting = records.some(record => record.status === "printing_awaiting");
  const createdAt = new Date(position.createdAt).toLocaleString();

  return (
    <>
      <Modal show={show} onHide={onClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>История статусов</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <PositionInfo position={position} createdAt={createdAt} />
          <hr />
          <StatusTimeline loading={loading} records={records} />
        </Modal.Body>

        <Modal.Footer>
          {hasPrintingAwaiting && (
            <Button 
              variant="primary" 
              onClick={() => setShowSheetsModal(true)} 
              className="me-auto"
            >
              Посмотреть листы
            </Button>
          )}
          <Button variant="secondary" onClick={onClose}>
            Закрыть
          </Button>
        </Modal.Footer>
      </Modal>

      <SheetsModal 
        show={showSheetsModal}
        onClose={() => setShowSheetsModal(false)}
        orderPositionId={position.orderPositionId}
      />
    </>
  );
}